export default __webpack_public_path__ + "static/2022-2023-pvd-quality-of-life-plan-hero-d32f1997eef73fe621fba232f1989da3.webp";